import React, { useMemo, useEffect, useRef } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  LinearProgress
} from '@material-ui/core';
import {
  fetchExplorePropertyData
} from 'store/actions';
import { prettifyFilterQueryWithoutIdentation } from 'components/explore/views/helpers';
import { fields } from '../../resultsGrid/gridHelpers/fields';
import { getPinColorIcon, colorPalettePresets } from "components/explore/gmap/colorHelper";
import classNames from 'classnames';
import { propertyGroupLevels } from "api/rex/spatial";

const PropertyDataObject = ({
  classes,
  object,
  mapType,
  bounds,
  groupLevel,
  requestedGroupLevel,
  filter,
  filterGeo,
  hasStateInstance,
  fetchExplorePropertyData,
  pinDisplayType,
  pinColorPaletteId,
  isMainIndicatorVisible
}) => {
  const isInitialMount = useRef(true);
  const filterExpression = object?.filter?.filterExpression;
  const filterValue = object?.filter?.filterValue

  useEffect(() => {
    if (!hasStateInstance) return;
    if (object.visible && object.isFilterSet) {
      const highlightPins = object.isCompsPdo && isInitialMount.current;
      fetchExplorePropertyData({ objectId: object.id, shouldFetch: true, highlightPins });
    }
    isInitialMount.current = false;
  }, [hasStateInstance, bounds, filter, filterGeo, object.visible, object.isFilterSet]);

  const improvedFilter = useMemo(() => {
    return prettifyFilterQueryWithoutIdentation(filterValue, fields, true);
  }, [filterExpression]);

  const { isFilterSet } = object;

  const pinColorId = object.pinDisplayType ? null : object.pinColorIds?.[mapType];

  const pinColorPalette = useMemo(() => {
    return colorPalettePresets.find(palette => palette.id === pinColorPaletteId);
  }, [pinColorPaletteId]);

  const getGroupLevelCaption = useMemo(() => {
    const level = propertyGroupLevels.find(level => level.value === groupLevel)?.caption;
    return requestedGroupLevel === 'auto' ? `Auto - ${level}` : level;
  }, [groupLevel, requestedGroupLevel]);

  return <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <div style={{ display: 'flex', margin: '-2px 0' }}>
      {pinColorId && isFilterSet
        ? <div className={classes.pinColorIconContainer}>
            <img alt='' src={getPinColorIcon(pinColorId)}/>
          </div>
        : pinDisplayType && pinDisplayType.dataType === 'number'
          ? <div style={{
              borderRadius: 3,                                        
              display: 'flex', 
              overflow: 'hidden',
              position: 'relative',
              marginRight: 4,
              alignItems: 'center'
            }}>
              <div style={{ position: 'absolute', width: '50%', height: '100%', background: `linear-gradient(to right, ${pinColorPalette.c0}, ${pinColorPalette.c1})` }}></div>
              <div style={{ position: 'absolute', width: '50%', height: '100%', background: `linear-gradient(to right, ${pinColorPalette.c1}, ${pinColorPalette.c2})`, right: 0 }}></div>
              <Typography className={classNames(classes.textSecondary, classes.coloringLegendItemText)}>{pinDisplayType.caption}</Typography>
            </div>
          : null
      }

      {groupLevel &&
        <Typography className={classes.textSecondary}>Cluster type: {getGroupLevelCaption}</Typography>
      }
      {/* {isMainIndicatorVisible &&
        <div style={{ marginLeft: 8 }}>
          <CircularProgress size={16} />
        </div>
      } */}
    </div>
    {filterGeo &&
      <div style={{ marginBottom: -2 }}>
        <Typography className={classes.textSecondary}>Geo filter applied</Typography>
      </div>
    }
    <div style={{ flexGrow: 1 }} />
    {(!isFilterSet || improvedFilter) &&
      <div style={{ marginBottom: -2 }}>
        <Typography className={classes.textSecondary}>{!isFilterSet ? <i>Needs filter set</i> : improvedFilter}</Typography>
      </div>
    }
    {isMainIndicatorVisible
      ? <LinearProgress style={{ margin: '2px -8px -3px'}}/>
      : <div style={{ height: 3 }} />
    }
  </div>;
}
const styles = theme => ({
  textSecondary: {
    fontSize: '.75rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  pinColorIconContainer: {
    height: 16,
    width: 16,
    marginRight: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  coloringLegendItemText: {
    marginLeft: 5,
    marginRight: 5,
    color: '#ffffff',
    zIndex: 1
  }
});

const mapStateToProps = ({ exploreMap, exploreData }, ownProps) => {
  const hasStateInstance = exploreData.propertyDataObjects[ownProps.object.id] != null;
  const propertyDataObject = exploreData.propertyDataObjects[ownProps.object.id];
  return {
    hasStateInstance,
    mapType: exploreMap.mapType,
    bounds: exploreMap.bounds,
    groupLevel: propertyDataObject?.groupLevel,
    requestedGroupLevel: propertyDataObject?.requestedGroupLevel,
    filter: propertyDataObject?.filter,
    filterGeo: propertyDataObject?.filterGeo,
    pinDisplayType: propertyDataObject?.pinDisplayType,
    pinColorPaletteId: propertyDataObject?.pinColorPaletteId,
    isMainIndicatorVisible: propertyDataObject?.isMainIndicatorVisible
  }
};
const mapDispatchToProps = {
  fetchExplorePropertyData
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PropertyDataObject);